import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { ButtonBase, Checkbox, Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Label from "../../components/Common/Label.js";
import LoadingDialog from "../../components/Common/LoadingDialog.js";
import Notification from "../../components/Common/Notification.js";
import Table from "../../components/Common/Table.js";
import TablePageControl from "../../components/Common/TablePageControl.js";
import CustomButton from "../../components/Form/CustomButton.js";
import Helpers from "../../helpers/helpers.js";
import { bulkAction, bulkDeleteAccessory, getAccessoryListing, resetAccessoryActionState, resetAccessoryState, toggleFeature } from "../../store/actions.js";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton.js";
import DeleteModal from "../../components/Common/DeleteModal.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import Toggle from "../../components/Common/Toggle.js";
import SearchBar from "../../components/Common/Searchbar.js";
import PopoverFilter2 from "../../components/Common/PopoverFilter2.js";
import AccessoriesMarkSold from "./modal/AccessoriesSold.js";
import AccessoriesMoveDraft from "./modal/AccessoriesMoveDraft.js";
import AccessoriesPublish from "./modal/AccessoriesPublish.js";
import AppDialog from "../../components/Common/AppDialog.js";

import PopOverFilter from "../../components/Common/PopoverFilter";
import moment from "moment";
import CustomTextField from "../../components/Form/CustomTextField.js";

const Accessories = ({ userPermission, accessoryListing, leftSideBarType, accessoryFeature, accessoryBulkAction, accessoryBulkDelete, width,
    categoryList, brandList, error
}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetAccessoryState());
    }, []);

    const [loading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [tabValue, setTabValue] = useState('all');
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("10");
    const [search, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("start");
    const [selectedRow, setSelectedRow] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [startSelecting, setStartSelecting] = useState(false);
    const [soldOpen, setSoldOpen] = useState(false);
    const [moveDraftOpen, setMoveDraftOpen] = useState(false);
    const [publishOpen, setPublishOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [selectedModules, setSelectedModules] = useState([]);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [exportable, setExportable] = useState(true);
    const [creatable, setCreatable] = useState(true);
    const [editable, setEditable] = useState(true);
    const [deletable, setDeletable] = useState(true);
    const [showAll, setShowAll] = useState(false);
    const itemsToShow = showAll ? selectedRow : selectedRow.slice(0, 2);
    const searchRef = useRef(search);

    //filter
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [filterObject, setFilterObject] = useState({ position: 'all', bannerType: 'all', advert_type: [], make: [], model: [], bike_type: [], licenseCategory: [] });


    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-marketing") && setCreatable(true);
            userPermission?.includes("edit-marketing") && setEditable(true);
            userPermission?.includes("delete-marketing") && setDeletable(true);
            userPermission?.includes("export-marketing") && setExportable(true);
        }
    }, [userPermission]);

    useEffect(() => {
        if (accessoryFeature?.code === 'success') {
            setNotification({
                open: true,
                type: 'success',
                msg: accessoryFeature?.message || 'Accessory updated successfully.'
            });
            dispatch(resetAccessoryActionState());
            initData();
        }
    }, [accessoryFeature])

    useEffect(() => {
        if (accessoryBulkDelete?.code === 'success') {
            setNotification({
                open: true,
                type: 'success',
                msg: accessoryBulkDelete?.message || 'Accessory deleted successfully.'
            });
            setDeleteOpen(false);
            dispatch(resetAccessoryActionState());
            initData();
        }
    }, [accessoryBulkDelete])

    useEffect(() => {
        if (accessoryBulkAction?.code === 'success') {
            moveDraftOpen && setMoveDraftOpen(false);
            publishOpen && setPublishOpen(false);
            soldOpen && setSoldOpen(false);
            selectedIds && setSelectedIds([]);
            selectedRow && setSelectedRow([]);
            setNotification({
                open: true,
                type: 'success',
                msg: accessoryBulkAction?.message || 'Accessory updated successfully.'
            });
            dispatch(resetAccessoryActionState());
            initData();
        }
    }, [accessoryBulkAction])

    useEffect(() => {
        if (accessoryListing?.data) {
            setIsLoading(false);
        }
    }, [accessoryListing])

    useEffect(() => {
        initData();
    }, [length, page, sort, sort_by]);

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    useEffect(() => {
        if (checkedAll) {
            let temp = accessoryListing && accessoryListing?.data?.data?.length > 0 ? accessoryListing?.data?.data?.map((x, idx) => x?.id) : []
            setSelectedIds(temp)
            setSelectedRow(accessoryListing?.data?.data || [])
        } else {
            setSelectedIds([])
            setSelectedRow([])
        }

    }, [checkedAll]);

    const dropdownList = [
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', color: '#1D1B1B', permission: editable, onClick: () => { setSoldOpen(true) } },
        // { iconName: 'solar:refresh-linear', label: 'Renew Selected', color: '#1D1B1B', permission: editable, onClick: () => { } },
        { iconName: 'solar:upload-minimalistic-linear', label: 'Publish Selected', color: '#1D1B1B', permission: editable, onClick: () => { setPublishOpen(true) } },
        // { iconName: 'solar:archive-down-minimlistic-linear', label: 'Move to Draft', color: '#1D1B1B', permission: editable, onClick: () => { setMoveDraftOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ];

    const deleteCheckBox = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <div className="text-center" onClick={(e) => e.stopPropagation()}>
                        <Checkbox
                            checked={checkedAll ? checkedAll : selectedIds && selectedIds?.length > 0 && selectedIds?.includes(cellProps.id)}
                            checkedIcon={Helpers.checkIcon()}
                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                            sx={{
                                '&.Mui-checked': {
                                    color: "#a0a0a0",
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: 18,
                                },
                            }}
                            value={cellProps.id}
                            onChange={(event) => { handleCheckboxChange(event.target.value, cellProps) }} />
                    </div>
                )
            },
        },
    ]

    const header = [
        {
            Header: "Accessories",
            minWidth: 300,
            accessor: (cellProps) => {
                return (
                    <div className="d-flex align-items-center">
                        <div className="me-2">
                            <img src={cellProps?.thumbnail_base64 || Helpers.noImage} alt="vehicle" style={{ width: 45, objectFit: 'contain' }} />
                        </div>
                        <div>
                            <div className="text-bold">{cellProps?.name || "-"}</div>
                            <div className="subheader-2 font-size-12">
                                {cellProps?.brand_name || "-"}
                                <span >{cellProps?.category_name ? ` / ${cellProps.sub_category_name}` : ""}</span>
                            </div>
                        </div>
                    </div>
                )
            },
        },
        {
            Header: "Price",
            accessor: (cellProps) => {
                return (
                    <>
                        <div className="text-bold">${cellProps?.selling_price || "0.00"}</div>
                    </>
                )
            },
        },
        {
            Header: 'Total View',
            headerIcon: <Icon icon={'fluent:info-24-regular'} style={{ color: '#808588', marginLeft: 5, fontSize: 18 }} />,
            accessor: (cellProps) => {
                return (cellProps?.total_views || "0")
            },
        },
        {

            Header: 'Total Inquiries',
            headerIcon: <Icon icon={'fluent:info-24-regular'} style={{ color: '#808588', marginLeft: 5, fontSize: 18 }} />,
            accessor: (cellProps) => {
                return (cellProps?.total_inquiries || "0")
            },
        },
        {
            Header: "Status",
            accessor: (cellProps) => {
                return (cellProps?.status ? <Label.GeneralStatusLabel label={cellProps.status} list={Helpers.accessoryStatus} marginLeft={"0px"} /> : "-")
            },
        },
        {
            Header: "Featured",
            accessor: (cellProps) => {
                return (
                    <div onClick={(e) => e.stopPropagation()}><Toggle checked={cellProps?.is_featured === 1 ? true : false} onChange={(e) => { handleToggleFeatured(cellProps.id, e.target.checked) }} /></div>
                )
            },
        },
    ]

    const filterList = [
        {
            module: 'Accessories',
            list: [
                { label: 'Mirrors', id: 'mirrors' },
                { label: 'Tyres', id: 'tyres' },
                { label: 'Wipers', id: 'wipers' },
                { label: 'Lights', id: 'lights' },
                { label: 'Audio Systems', id: 'audio-systems' }
            ]
        },
        {
            module: 'Warranty',
            list: [
                { label: 'Basic', id: 'basic' },
                { label: 'Extended', id: 'extended' },
                { label: 'Premium', id: 'premium' }
            ]
        },
    ]
    const filterList2 = [
        {
            label: "Brand",
            type: "checkbox",
            value: filterObject?.brand || [],
            data: brandList,
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    brand: e,
                }))
            }
        },
        {
            type: "checkbox_by_cat", // Type of filter
            label: "Category", // Main label for the filter
            categories: categoryList,
            values: filterObject?.categories, // Object to store selected values for each category
            onCategoryChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    categories: e,
                }))
            },
            onChangeSelectedModule: setSelectedModules,
            selectedModules: selectedModules,
        },
        {
            label: "Price Range",
            type: "priceRange",
            minValue: filterObject?.min_price || "",
            maxValue: filterObject?.max_price || "",
            prefix: "$",
            setMinAmount: (value) => {
                setFilterObject({ ...filterObject, min_price: value })
            },
            setMaxAmount: (value) => {
                setFilterObject({ ...filterObject, max_price: value })
            },
        },
        {
            label: "Accessory Status",
            type: "checkbox",
            value: filterObject?.status || [],
            data: [
                { label: "Draft", value: "Draft" },
                { label: "Published", value: "Published" },
                { label: "Sold", value: "Sold" },
                { label: "Inactive", value: "Inactive" },
            ],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    status: e,
                }))
            }
        },
        {
            label: "Created Date",
            value: filterObject?.createdDate,
            type: "date_range",
            startPlaceholder: "From",
            endPlaceholder: "To",
            startDateTitle: "Fom",
            startDate: startDate,
            setStartDate: (date) => {
                setStartDate(date);
                const formattedDate = date ? moment(date).format('DD/MM/YYYY') : "";
                setFilterObject((prev) => ({ ...prev, from: formattedDate }));
            },
            endDateTitle: "To",
            endDate: endDate,
            setEndDate: (date) => {
                setEndDate(date);
                const formattedDate = date ? moment(date).format('DD/MM/YYYY') : "";
                setFilterObject((prev) => ({ ...prev, to: formattedDate }));
            },
            xsGrid: 12, smGrid: 12, mdGrid: 12
        },
    ]


    const initData = () => {
        dispatch(getAccessoryListing({
            page: page,
            size: length,
            // sort: sort,
            // sort_by: sort_by,
            search: searchRef.current || '',

            category_id: selectedModules || [],
            sub_category_id: filterObject?.categories || [],
            brand_id: filterObject?.brand || [],
            price_min: filterObject?.min_price,
            price_max: filterObject?.max_price,
            from: filterObject?.from || "",
            to: filterObject?.to || "",
            status: filterObject?.status,

        }))
    }

    const resetFilter = () => {
        setSortBy("")
        setSorted("")
        setPage((prevPage) => (prevPage === 1 ? '1' : 1));
        setFilterObject({ advert_type: [], make: [], model: [], bike_type: [], licenseCategory: [] })
        setSelectedModules([])
        setStartDate("");
        setEndDate("");
        setSearch(""); // Clear search keyword
        searchRef.current = ""; // Update searchRef
    }

    const applyFilter = (sort, sortBy) => {
        setSortBy(sortBy || 'id');
        setSorted(sort || 'desc');
        setPage(page === 1 ? '1' : 1);
        setDrawerOpen(false);
    }

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value
        }));
        setPage(page === "1" ? 1 : "1");
    };

    const handleCheckboxChange = (e, item) => {
        let temp = [];
        let tempItem = [];
        if (selectedIds && selectedIds?.includes(parseInt(e))) {
            temp = selectedIds.filter((x) => x !== parseInt(e)).map((y) => y);
            tempItem = selectedRow.filter((x) => x.id !== parseInt(e)).map((y) => y);
            setSelectedRow(tempItem)
            setSelectedIds(temp)
        } else {
            setSelectedIds([...selectedIds, parseInt(e)])
            setSelectedRow([...selectedRow, item])
        }
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage(page === "1" ? 1 : "1");
            }
        }, Helpers.searchInterval);
    }

    const handleDelete = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({
                open: true,
                type: 'error',
                msg: 'Please select at least one accessory to delete.'
            });
            return;
        }

        setIsLoading(true);
        dispatch(bulkDeleteAccessory({ ids: selectedIds }));
    }

    const handleMarkAsSold = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({
                open: true,
                type: 'error',
                msg: 'Please select at least one accessory to mark as sold.'
            });
            return;
        }
        setIsLoading(true);
        let payload = {
            ids: selectedIds,
            status: 'sold'
        }
        dispatch(bulkAction(payload))
    }

    const handleMoveToDraft = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({
                open: true,
                type: 'error',
                msg: 'Please select at least one accessory to move to draft.'
            });
            return;
        }
        setIsLoading(true);
        let payload = {
            ids: selectedIds,
            status: 'draft'
        }
        dispatch(bulkAction(payload))
    }

    const handlePublish = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({
                open: true,
                type: 'error',
                msg: 'Please select at least one accessory to publish.'
            });
            return;
        }
        setIsLoading(true);
        let payload = {
            ids: selectedIds,
            status: 'published'
        }
        dispatch(bulkAction(payload))
    }

    const handleToggleFeatured = (id, value) => {
        setIsLoading(true);
        dispatch(toggleFeature({ id: id, is_featured: value ? 1 : 0 }));
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={9} md={10} sm={10} xs={12} style={{ display: 'flex', alignItems: "center" }} spacing={1} rowSpacing={2}>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                        <SearchBar
                            value={search}
                            module={'brand or name'}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item md={3} sm={3} xs={6}>
                        <PopoverFilter2
                            module={'Category'}
                            title={'Categories'}
                            value={filterObject?.categories || 'all'}
                            filterData={categoryList?.length > 0 && categoryList?.map(x => (
                                {
                                    module: x?.id,
                                    name: x?.name,
                                    id: x?.id,
                                    list: x?.sub_categories?.length > 0 ? x.sub_categories.map(sub => ({ label: sub.name, id: sub.id })) : [],
                                }
                            ))}
                            setValue={(e) => { handleFilterChange('categories', e) }}
                            onChangeMoculeCatgory={(e) => setSelectedModules(e)}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} sm={3} xs={6}>
                        <PopOverFilter
                            setDialogOpen={setDrawerOpen}
                            open={drawerOpen}
                            applyFilter={applyFilter}
                            filterData={filterList2}
                            setFilterObject={setFilterObject}
                            sort={sort}
                            sort_by={sort_by}
                            filterList={filterList}
                            handleResetFilter={resetFilter}
                        />
                    </Grid>
                </Grid>
                <Grid item lg={3} md={2} sm={2} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end', sm: 'end' } }} alignItems={'center'}>
                    <CustomButton
                        title={'Select'}
                        press={() => setStartSelecting(!startSelecting)}
                        height={32}
                        backgroundColor={startSelecting ? '#F5F5F5' : 'white'}
                        textColor={'#000'}
                        borderStyle={startSelecting ? "1px solid #E3E8EE" : "1px solid #babcbe"}
                        marginRight={startSelecting ? 5 : 0}
                    />
                    {
                        startSelecting &&
                        <RenderPopOverButton
                            items={dropdownList}
                            customTitle={
                                <CustomButton
                                    title={<>Bulk Actions<Icon icon={'fluent:chevron-down-20-regular'} style={{ marginLeft: 10, color: '#525252CC' }} /></>}
                                    press={() => { }}
                                    height={32}
                                    backgroundColor={'white'}
                                    textColor={'#000'}
                                    borderStyle={"1px solid #babcbe"}
                                />
                            }
                        />
                    }

                </Grid>
            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center p-1 pb-4">
                <div className="header-2 d-flex align-items-center">Accessories <div className="header-amount mx-2">{accessoryListing?.total || 0}</div></div>
                {
                    creatable &&
                    <CustomButton
                        title={<><i className="ri-add-line" style={{ marginRight: '5px' }} />Create new accessory</>}
                        borderStyle={'1px solid #101010'}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        press={() => navigate('/add-accessory')}
                        padding={20}
                    />
                }
            </div>
        )
    }

    const mobileView = () => {
        return (
            <div>
                <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                    <div className="d-flex align-items-cente text-semibold font-size-16">{accessoryListing?.total || 0} Listings</div>
                    <ButtonBase style={{ borderRadius: '100%' }} onClick={() => navigate('/add-accessory')}>
                        <Icon icon={'ri:add-circle-fill'} style={{ height: 28, width: 28 }} />
                    </ButtonBase>
                </div>
                <CustomTextField
                    values={search}
                    onChange={(e) => setSearch(e)}
                    placeholder={'Search by make, model, title or reg. no'}
                    InputProps={{ startAdornment: <Icon icon={'fluent:search-16-regular'} style={{ marginRight: 8, height: 20, width: 20 }} /> }}
                    backgroundColor={'#FAFAFA'}
                    borderRadius={57}
                />
                <div className="d-flex align-items-center my-3 gap-2" style={{ flexWrap: 'wrap' }}>
                    <CustomButton
                        title={'Select'}
                        press={() => setStartSelecting(!startSelecting)}
                        height={32}
                        backgroundColor={startSelecting ? '#F5F5F5' : 'white'}
                        textColor={'#000'}
                        borderStyle={startSelecting ? "1px solid #E3E8EE" : "1px solid #babcbe"}
                        marginRight={5}
                    />
                    {
                        startSelecting &&
                        <RenderPopOverButton
                            items={dropdownList}
                            customTitle={
                                <CustomButton
                                    title={<>Bulk Actions<Icon icon={'fluent:chevron-down-20-regular'} style={{ marginLeft: 10, color: '#525252CC' }} /></>}
                                    press={() => { }}
                                    height={32}
                                    backgroundColor={'white'}
                                    textColor={'#000'}
                                    borderStyle={"1px solid #babcbe"}
                                    marginRight={5}
                                    width={150}
                                />
                            }
                        />
                    }
                    <PopOverFilter
                        setDialogOpen={setDrawerOpen}
                        open={drawerOpen}
                        applyFilter={applyFilter}
                        filterData={filterList2}
                        setFilterObject={setFilterObject}
                        sort={sort}
                        sort_by={sort_by}
                        filterList={filterList}
                        handleResetFilter={resetFilter}
                    />
                </div>
                {
                    Array.isArray(accessoryListing?.data) && accessoryListing?.data.length > 0 && accessoryListing?.data.map((item) => {
                        return (
                            <div className="d-flex align-items-center py-2" style={{ borderBottom: '1px solid #E2E2E2' }} onClick={() => navigate(`/accessories/${item?.id}`)}>
                                {
                                    startSelecting &&
                                    <div className="text-center" onClick={(e) => e.stopPropagation()}>
                                        <Checkbox
                                            checked={checkedAll ? checkedAll : selectedIds && selectedIds?.length > 0 && selectedIds?.includes(item.id)}
                                            checkedIcon={Helpers.checkIcon()}
                                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: "#a0a0a0",
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 18,
                                                },
                                            }}
                                            value={item.id}
                                            onChange={(event) => { handleCheckboxChange(event.target.value, item) }} />
                                    </div>
                                }
                                <div style={{ marginRight: 10 }}>
                                    <img src={item?.thumbnail_base64 || Helpers.noImage} alt="vehicle" style={{ width: 45, objectFit: 'contain' }} />
                                </div>
                                <div >
                                    <div className="text-bold">{item?.name || "-"}</div>
                                    <div className="align-items-center d-flex">
                                        <Label.GeneralStatusLabel label={item.status} list={Helpers.accessoryStatus} marginLeft={"0px"} />
                                        <div className="mx-2 text-semibold">${item?.selling_price || "-"}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

            </div>
        )
    }

    const handleCheckedAll = () => {
        if (isAllAdvertSelected) {
            const selectedRemoveRow = accessoryListing?.data || [];
            const selectedRemoveIds = selectedRemoveRow.map((item) => item.id);
            setSelectedIds(selectedIds.filter(id => !selectedRemoveIds.includes(id)));
            setSelectedRow(selectedRow.filter(row => !selectedRemoveRow.some(item => item.id === row.id)));
        } else {
            const currentSelectedIds = Array.isArray(selectedIds) ? selectedIds : [];
            const currentSelectedRows = Array.isArray(selectedRow) ? selectedRow : [];
            const existingIdSet = new Set(currentSelectedIds);
            const incomingRows = accessoryListing?.data || [];
            const newRows = incomingRows.filter((item) => !existingIdSet.has(item?.id));
            const newIds = newRows
                .map((item) => item?.id)
                .filter((id) => id !== undefined && id !== null);

            setSelectedIds([...currentSelectedIds, ...newIds]);
            setSelectedRow([...currentSelectedRows, ...newRows]);
        }
    }

    const isAllAdvertSelected =
        Array.isArray(accessoryListing?.data) &&
        accessoryListing.data.length > 0 &&
        Array.isArray(selectedIds) &&
        accessoryListing.data.every((item) => selectedIds.includes(item?.id));


    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || !accessoryListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} errors={error} />

                    {
                        width <= 768 ? mobileView() :
                            <>
                                {renderHeader()}
                                {customToolsBar()}
                                <Table
                                    header={startSelecting ? [...deleteCheckBox, ...header] : header}
                                    data={accessoryListing?.data}
                                    pageSize={length}
                                    totalPage={accessoryListing?.last_page || 1}
                                    customToolsBar={true}
                                    sort={sort}
                                    setSorted={setSorted}
                                    sort_by={sort_by}
                                    setSortBy={setSortBy}
                                    setCheckedAll={handleCheckedAll}
                                    checkedAll={isAllAdvertSelected}
                                    onTableRowClick={(row) => navigate(`/accessories/${row?.id}`)}
                                />
                            </>
                    }

                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={accessoryListing?.last_page || 1}
                    />
                    <AppDialog
                        open={deleteOpen}
                        close={() => setDeleteOpen(false)}
                        title={`Delete Selected Accessories`}
                        positiveTitle={'Delete'}
                        positiveButtonStyle={{ backgroundColor: '#D13536', color: 'white', borderRadius: 20, width: 'auto', border: '1px solid #D13536' }}
                        positivePress={() => handleDelete()}
                        cancelButton={true}
                        width={'40%'}
                        windowWidth={width}
                    >
                        <div>Are you sure you want to delete {selectedRow.length} selected accessories?</div>
                        <ol style={{ paddingInline: 20, paddingBlock: 10 }}>
                            {itemsToShow?.map((item, idx) => (
                                <li key={idx} className="mb-2 ">
                                    <div className="d-flex align-items-center">
                                        {item?.name || '-'}
                                        <Label.GeneralStatusLabel label={item?.status || '-'} list={Helpers.accessoryStatus} marginLeft={"10px"} />
                                    </div>
                                </li>
                            ))}
                            {selectedRow.length > 2 && (
                                <div
                                    onClick={() => setShowAll(!showAll)}
                                    className="clickable underline"
                                    style={{ marginTop: '10px' }}
                                >
                                    {showAll ? 'Show less' : 'Show more'}
                                </div>
                            )}
                        </ol>
                        <div className="my-2">Once deleted:</div>
                        <ul className="subheader-2" style={{ padding: 5, paddingInline: 15 }}>
                            <li className="mb-2">The accessories will be permanently removed from the marketplace.</li>
                            <li className="mb-2">Enquiries and performance data for the selected accessories will be lost.</li>
                        </ul>
                    </AppDialog>
                    <AccessoriesMarkSold
                        open={soldOpen}
                        close={() => setSoldOpen(false)}
                        handleSubmit={() => { handleMarkAsSold() }}
                        windowWidth={width}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                    />
                    <AccessoriesMoveDraft
                        open={moveDraftOpen}
                        close={() => setMoveDraftOpen(false)}
                        handleSubmit={() => { handleMoveToDraft() }}
                        windowWidth={width}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                    />
                    <AccessoriesPublish
                        open={publishOpen}
                        close={() => setPublishOpen(false)}
                        handleSubmit={() => { handlePublish() }}
                        windowWidth={width}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Accessory, Layout, General }) {
    return {
        userPermission: Login.permissionArry,
        accessoryListing: Accessory?.accessoryListing?.data,
        leftSideBarType: Layout.leftSideBarType,
        accessoryFeature: Accessory.accessoryToggleFeature,
        width: Layout.currentWidth,
        accessoryBulkAction: Accessory?.accessoryBulkAction,
        error: Accessory?.error,
        accessoryBulkDelete: Accessory?.accessoryBulkDelete,
        brandList: General.brand?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
        categoryList: General.category || [],
    };
}

export default connect(mapStateToProps)(Accessories);
